import { gojsStickyNoteCursor } from '../../../assets/cursors';
import { sidebarNodeTypes } from '../../../config/config';
import { BaseApi } from '../../common/api/base-api.interface';
import { StickyNodeCreateProps } from '../models/sticky-node-create-props';
import { getApiForNodeType } from './../../common/api/api-map';
import { createStickyNode } from './create-sticky-node';
import { setupStickyNode } from './setup-sticky-node';

export const stickyNodeAPI = (): BaseApi<StickyNodeCreateProps> => ({
  name: sidebarNodeTypes.stickyNode,
  setup: setupStickyNode,
  create: createStickyNode,
  getCursor: () => gojsStickyNoteCursor,
  ...getApiForNodeType(sidebarNodeTypes.stickyNode),
});
